import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";
import GameUtil from "../../../../utility/game_util";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";


class friendUtils {

    private _friendList: any[];
    public get friendList(): any[] {
        return this._friendList;
    }

    
    private _inviteList : any[];
    public get inviteList() : any[] {
        return this._inviteList;
    }
      
    private reqFriendRed: boolean;    
    

    private _sysConfig : any;

    //获取玩家间可赠送次数
    get handselCnt(){
        return this._sysConfig? Number(this._sysConfig["player.handsel.count"]) : 0;
    }

    //获取玩家间赠送额度
    get handselNum(){
        return this._sysConfig ? Number(this._sysConfig["player.handsel.num"]) : 0;
    }

    //玩家可转账等级
    get transferLev(){
        return this._sysConfig ? Number(this._sysConfig["player.all.transfer.level"]) : 0;
    }

    //获取玩家每日最小转账额度
    get transferMinNum(){
        return this._sysConfig ? Number(this._sysConfig["player.min.transfer.num"]): 0;

    }
    //获取玩家每日最大转账数量
    get transferMaxNum(){
        return this._sysConfig ? Number(this._sysConfig["player.day.transfer.num"]): 0;
    }

    //转账手续费
    get transferTaxes(){
        return this._sysConfig ? Number(this._sysConfig["player.transfer.taxes"]) : 0;
    }
   
    init() {

        this.reqFriendRed = false;
        this._friendList = null;
        this._inviteList = null;
        this._sysConfig = null;
        this.reqFriendList(null,null);
        
    }

    reqSysConfig(callback?:( config : any)=>void , showNetPrompt? : boolean ){

        if (this._sysConfig) {         
            callback && callback(this._sysConfig);                   
        }else{
            let self = this
            ModelData.instance.httpGetAppRemoteConfigData((data) => {
                self._sysConfig = data
                callback && callback(data)
            },false,showNetPrompt)
        }

    }

    //不能转账判断提示
    showTransferTip(){

        let avatarLv = ModelData.instance.roleData.userLevel;
        //判断原因
        this.reqSysConfig((config)=>{
            let reqLev = config["player.all.transfer.level"];
            if (avatarLv < reqLev) {                    
                ModuleManager.instance.toastKey("friend_transfer_level_not_enough");
            }else{
                ModuleManager.instance.toastKey("friend_transfer_quota");
            }
        });
    }

    /**
     * 请求好友列表
     * @param mvvmBase 
     * @param callback 
     * @param useMemory 
     */
    reqFriendList(mvvmBase: MVVMBase, callback: (friendList: any[]) => void, useMemory: boolean = false) {

        if (!this._friendList || this._friendList.length == 0 || !useMemory) {

            let requestData: IHttpRequestData = {

                baseUrl: 'friendship/getFriendList?',
                params: {
                    status: 1,
                }

            }
            let self = this;
            if (null != mvvmBase) {
                 
                mvvmBase.apiHttpGet(requestData, (response) => {

                    if (response.code == 'SUCCESS' && mvvmBase.normalShow) {
    
                        self._friendList = response.data;
                        if (callback) {
                            callback(self._friendList);
                        }
                    }
                });
            }else{
                GameUtil.apiHttpGet(requestData, (response : IHttpApiResponeData) => {                   
                        if (response.code == "SUCCESS") {
                            self._friendList = response.data;
                            if (callback) {
                                callback(self._friendList);
                            }
                        }                     
                })
                
            }            

        } else {

            if (callback) {
                callback(this._friendList);
            }
        }
    }


    /**
     * 增加好友
     * @param friendId 
     * @param mvvmBase 
     * @param callback 
     */
    addFriend(friendId: number, mvvmBase: MVVMBase, callback?: (result: boolean) => void) {

        let requestData = {

            baseUrl: 'friendship/addFriend?',
            params: {
                friendId: friendId
            }

        }
        let self = this;
        mvvmBase.apiHttpGet(requestData, (response) => {

            console.log(" addFriend data : ", response);
            if (response.code == 'SUCCESS' && response.data) {
                
                self.reqFriendList(mvvmBase,()=>{
                    if (callback) {
                        callback(true);                        
                    }                    
                    mvvmBase.eventDispatch("friend_add_friend",friendId);                    
                })
                ModuleManager.instance.toastKey("friend_add_friend_success")
            } else {
                if (callback) {
                    callback(false);
                }
            }
        })
    }
    

    /**
     * 移除好友
     * @param friendId 
     * @param mvvmBase 
     * @param callback 
     */
    removeFriend(friendId: number, mvvmBase: MVVMBase, callback?: (result: boolean) => void) {

        let requestData: IHttpRequestData = {

            baseUrl: 'friendship/deleteFriend?',
            params: {
                friendId: friendId
            }
        }
        let self = this;
        mvvmBase.apiHttpGet(requestData, (response) => {
            
            if (response.code == 'SUCCESS' && response.data) {
                
                self._friendList = self._friendList.filter((value)=>{
                    return (value.friendId != friendId);                                            
                });

                mvvmBase.eventDispatch("friend_remove_friend",friendId);                    

                if (callback) {
                    callback(true)
                }
            }
            
        })
    }

    reqInviteList(mvvmBase: MVVMBase, callback: (inviteList: any[]) => void){

        let requestData : IHttpRequestData = {

            baseUrl : 'friendship/getInviteList?',
            params : {
                status : 0,
            },

            showNetPrompt : true
        }

        let self = this;
        mvvmBase.apiHttpGet(requestData,(response : any)=>{

            console.log(" friendship data : " , response);
            if (response.code == 'SUCCESS') {   

                self._inviteList = response.data;
                if (callback) {
                    callback(self._inviteList);
                }
            }
        });
    }

    /**
     * 是否为自己的好友检测
     * @param uuid 
     * @param mvvm 
     * @param callback 
     */
    isFriend(uuid: number, mvvm: MVVMBase, callback: (result: boolean) => void) {

        let self = this;
        if (!this._friendList) {

            this.reqFriendList(mvvm, () => {

                callback(self.checkFriend(uuid));
            });

        } else {

            callback(this.checkFriend(uuid));
        }
    }

    /**
     * 是否为邀请的好友
     * @param uuid 
     * @param mvvm 
     * @param callback 
     */    
    isInvite(uuid: number, mvvm: MVVMBase, callback: (result: boolean) => void) {

        let self = this;
        if (!this._friendList) {

            this.reqFriendList(mvvm, () => {

                callback(self.checkInivte(uuid));
            });

        } else {

            callback(this.checkInivte(uuid));
        }
    }

    /**
     * 好友赠送
     * @param receiveUserId 
     * @param callback 
     * @param objType 
     */
    reqHandsel(receiveUserId : number,callback?: (result: boolean) => void,objType : number = 1){

        let requestData: IHttpRequestData = {
            baseUrl: 'friendship/handsel?',
            params: {
                accountType : 6,
                receiveUserId: receiveUserId,
                handselObjectType : objType,
                //num : this.handselNum,
            }
        }


        let self = this;
        GameUtil.apiHttpGet(requestData, (response : IHttpApiResponeData) => { 

            if (callback) {
                callback(response.code == 'SUCCESS' && response.data)
            }
        })
    }

    
    /**
     * 是否允许赠送
     * @param receiveUserId 
     * @param objType  类型:1 货币 2 物品 默认1
     */
    isAllowHandsel(currency : number, receiveUserId : number,callback?: (result: boolean) => void){        

        if (currency < this.handselNum) {
            if (callback){
                callback(false);
            }
            return;
        }

        let requestData: IHttpRequestData = {
            baseUrl: 'friendship/isAllowHandsel?',
            params: {
                accountType : 6,
                receiveUserId: receiveUserId,
                transferObjectType : 1,
                //num : this.handselNum
            }
        }
        let self = this;        
        GameUtil.apiHttpGet(requestData, (response : IHttpApiResponeData) => {                   

            if (callback) {
                callback(response.code == 'SUCCESS' && response.data)
            }
        })

    }
    

    private _todayRemain : number;
    public get todayRemain(){
        return this._todayRemain;
    }
    //今日剩余转账额度
    getTodayRemain(callback : (remain : number)=>void ){

        let requestData: IHttpRequestData = {
            baseUrl: 'friendship/getTodayRemain?',
            params: {
            }
        }
        let self = this;
        GameUtil.apiHttpGet(requestData, (response : IHttpApiResponeData) => { 

            if (response.code == 'SUCCESS') {                
                self._todayRemain = response.data;
                if (callback) {
                    callback(response.data)
                }
            }
           
        })
    }

    //转账
    reqTransfer(num : number, friendId : number,callback : (result : boolean)=>void,mvvmBase? : MVVMBase ){

        let requestData: IHttpRequestData = {
            baseUrl: 'friendship/transfer?',
            params: {
                receiveUserId : friendId,
                num : num,
            }
        }

        let self = this;
        if (mvvmBase) {
            
            mvvmBase.apiHttpGet(requestData,(data)=>{
                if (callback && data.code == "SUCCESS") {
                    callback(data.data);
                }
            });
        }else{

            GameUtil.apiHttpGet(requestData, (data : IHttpApiResponeData) => { 

                if (callback && data.code == "SUCCESS") {
                    callback(data.data);
                }
            });
        }
 
      
    }

    //未处理邀请
    getUnprocessedInvite(mvvmBase: MVVMBase,callback : (result : boolean)=>void ){

        //只需请求一次
        if (this.reqFriendRed) {
            return;
        }

        let requestData: IHttpRequestData = {
            baseUrl: 'friendship/getUnprocessedInvite?',
            params: {
            }
        }

        let self = this;
        mvvmBase.apiHttpGet(requestData, (response) => {
            if (callback && response.code == 'SUCCESS') {

                self.reqFriendRed = true;
                callback(response.data);
            }
        })
    }

    private checkFriend(uuid: number) {

        for (let index = 0; index < this._friendList.length; index++) {
            let data = this._friendList[index];
            if (data.friendId == uuid) {

                return true;
            }
        }

        return false;
    }

    private checkInivte(uuid: number) {

        for (let index = 0; index < this._inviteList.length; index++) {
            let data = this._inviteList[index];
            if (data.friendId == uuid) {

                return true;
            }
        }

        return false;
    }

}


export let friend_utils = new friendUtils();